import { IdPspNavigation } from "../../interfaces/serviceModels/IRequestJSON";
import { setPSPCONTENTOBJECT } from "../constants/pspContentObject.types";

export const setPspContentObject = (pspObject: IdPspNavigation) => {
  return {
    type: setPSPCONTENTOBJECT,
    payload: pspObject,
  };
};
